export const environment = {
  production: true,
  apiEndpoint: 'https://back-escritoriodigital.junji.gob.cl/api-mgcep/'
};
